import React from 'react';
import styled from 'styled-components';
import Icon from 'components/lib/icons/icon';

export default props => (
  <StyledIcon viewBox="0 0 13 11" {...props}>
    <path d="M1 7h11M1 10h7M1 1h11M1 4h11" strokeLinecap="round" strokeWidth="1.2" />
  </StyledIcon>
);

const StyledIcon = styled(Icon)`
  width: 16px;
  stroke: ${p => p.theme.colors.gray900};
`;
